export default {
  documentos: [],
  subiendo: false,
  cargando: false,
}
